'use client';
import React, { useEffect, useState, useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import SolutionSingle from '@/components/common/ui/single-item/SolutionSingle';
import getSolutionDataJson from '@/public/json/page/solution-spectrum.json';
import { StyledSolutionList } from '@/components/common/ygen/sections/solution-list/solution-list.style';

const SolutionList = ({ data }) => {
	const [getSolutionData, setSolutionData] = useState(getSolutionDataJson);

	// Memoize the list of solutions
	const solutionsList = useMemo(() => {
		return getSolutionData?.child_pages?.list || [];
	}, [getSolutionData]);

	// Memoize the render function for each solution
	const renderSolutionItem = useMemo(() => {
		return solutionsList.map((e, index) => {
			const thumb = e?.images?.list?.find((f) => f?.thumb === 'on');
			return (
				<Col md={4} key={index} className={'fade-up'}>
					<SolutionSingle
						link={`/solutions/${e?.page_data?.slug}`}
						img={thumb?.full_path}
						description={e?.page_data?.short_desc}
						title={e?.page_data?.title}
						count={index + 1}
					/>
				</Col>
			);
		});
	}, [solutionsList]);

	useEffect(() => {
		if (getSolutionDataJson) {
			setSolutionData(getSolutionDataJson);
		}
	}, []); // Empty dependency array since we only need to set initial data

	return (
		<StyledSolutionList className="JobList" data-scroll-section>
			<Container>
				<Row className="masonary-row">
					{renderSolutionItem}
				</Row>
			</Container>
		</StyledSolutionList>
	);
};


export default React.memo(SolutionList);
